import { render, staticRenderFns } from "./CellRendererFolder.vue?vue&type=template&id=754c65e3"
import script from "./CellRendererFolder.vue?vue&type=script&lang=js"
export * from "./CellRendererFolder.vue?vue&type=script&lang=js"
import style0 from "./CellRendererFolder.vue?vue&type=style&index=0&id=754c65e3&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports